import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { MONEY_FORMAT } from 'constants/formats';
import { NumberBox, SelectBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import {
  useChangeCashFlowExpenseSalaryDetailMutation,
  useCreateCashFlowExpenseSalaryDetailMutation,
  useLazyGetCashFlowExpenseSalaryDetailQuery,
} from 'bus/cash';
import { CashFlowExpenseSalaryDetailItem } from 'bus/cash/types/cashFlowExpenseSalary';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
  cashFlowId: number;
};

const initialForm: CashFlowExpenseSalaryDetailItem = {
  employeeId: null,
  toPay: 0,
  issued: false,
  dateBegin: '',
  dateEnd: '',
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id, cashFlowId }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<CashFlowExpenseSalaryDetailItem>(initialForm);
  const [postId, setPostId] = useState('');

  const [loadCashFlowExpenseSalary] = useLazyGetCashFlowExpenseSalaryDetailQuery();
  const [createCashFlowExpenseSalary, { isLoading: isLoadingCreate }] = useCreateCashFlowExpenseSalaryDetailMutation();
  const [changeCashFlowExpenseSalary, { isLoading: isLoadingChange }] = useChangeCashFlowExpenseSalaryDetailMutation();

  const disabledSubmit = isLoadingCreate || isLoadingChange;

  const onShown = async () => {
    if (id) {
      const result = await loadCashFlowExpenseSalary({ cashFlowId, detailId: id });
      setForm(result.data!);
    } else {
      setForm(initialForm);
    }
  };

  const employeeDateSource = useMemo(() => {
    return $createDataSource('/v1/employee', 'id');
  }, []);

  const postsDateSource = useMemo(() => {
    return $createDataSource('/v1/post', 'id');
  }, []);

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await changeCashFlowExpenseSalary({ ...form, cashFlowId, detailId: id });
      } else {
        await createCashFlowExpenseSalary({ ...form, cashFlowId, detailId: id });
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Расходы на зарплату"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="ФИО" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={employeeDateSource}
                            displayExpr="fullName"
                            valueExpr="id"
                            value={form.employeeId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, employeeId: e.itemData.id }));
                            }}
                            onOptionChanged={(e) => {
                              if (e.value?.postId) {
                                setPostId(e.value?.postId);
                              }
                            }}
                          >
                            <DropDownOptions
                              title="Выберите контрагента"
                              closeOnOutsideClick={true}
                              showTitle={false}
                            />
                            <Validator>
                              <RequiredRule message="Выберите контрагента" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        {/* <AppFiledBox label="Дата начала" labelTop>
                              <DateBox
                            stylingMode="underlined"
                              type="date"
                              onValueChange={(e) => setForm((prev) => ({ ...prev, dateBegin: e  as string }))}
                              useMaskBehavior
                              dateSerializationFormat="yyyy-MM-dd"
                              value={form.dateBegin}
                          >
                          </DateBox>
                        </AppFiledBox>

                      <AppFiledBox label="Дата окончания" labelTop>
                          <DateBox
                            stylingMode="underlined"
                              type="date"
                              onValueChange={(e) => setForm((prev) => ({ ...prev, dateEnd: e  as string }))}
                              useMaskBehavior
                              dateSerializationFormat="yyyy-MM-dd"
                              value={form.dateEnd}
                          >
                          </DateBox>
                      </AppFiledBox> */}

                        <AppFiledBox label="Должность" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={postsDateSource}
                            displayExpr="name"
                            valueExpr="id"
                            value={postId}
                            readOnly
                          ></SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Сумма, руб." labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format={MONEY_FORMAT}
                            value={form.toPay}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, toPay: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Сумма, руб." />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={disabledSubmit}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
